import {MultilingualData} from '@clients/member-direct/translation';

import {SurveyElement} from './ISurveyElement';
import { guid } from '@clients/shared/utilities';

export interface ISurveyBlock {
    id: string;
    label: string;
    heading?: MultilingualData<string>;
    content: SurveyElement[];
    completed?: boolean;
    intro?: boolean;
    movePage?: boolean;
    config?: SurveyBlockConfig;
    setId?: (id: string) => void;
    contentId?: string;
    footer?: MultilingualData<string>;
}

export interface SurveyBlockConfig {
    block?: {
        manualBlockNavigation?: {
            enabled: boolean;
            nextBlockId?: string;
        };
        display?: {
            renderInSidebarBlockNavigation?: boolean;
        };
    };
    questions?: {
        advanceAlways?: {
            enabled: boolean;
            nextBlockId?: string;
        };
        showPreview?: {
            enabled: boolean;
            previewCount?: number;
        };
        showBlockHeading?: {
            enabled: boolean;
        };
        scrollMode?: {
            enabled: boolean;
            disableQuestionSkipping?: boolean;
        };
        singleQuestionMode?: {
            enabled: boolean;
        };
        showQuestionCounter?: {
            enabled: boolean;
        };
    };
}

export class SurveyBlockCreator implements ISurveyBlock {
    public id = guid();
    public label = 'Block';
    public content = [];
    public completed: boolean;
    public intro: boolean;
    public movePage?: boolean;
    public footer?: MultilingualData<string>;

    /* istanbul ignore next */
    constructor(content: SurveyElement[] = null, completed = false, intro = false, movePage = false, footer?: MultilingualData<string>) {
        this.content = content;
        this.completed = completed;
        this.intro = intro;
        this.movePage = movePage;
        this.footer = footer;
    }

    public setId(id: string) {
        this.id = id;
    }
}
